import UserService from "../keycloak/UserService";

const PublicRoute = ({ children }) => {
  if (children.isPrivateRoute) {
    UserService.doLogin({
      redirectUri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URL,
    });
  }
  return children?.element;
};

export default PublicRoute;
